module.exports = __webpack_public_path__ + "img/arrow-right-white.d6cffdc8.svg";